export default "__VITE_PUBLIC_ASSET__332cdc73__"